if (!customElements.get('pdp-packs')) {
  customElements.define(
    'pdp-packs',
    class PdpPacks extends HTMLElement {
      connectedCallback() {
        this.qtyInput = this.querySelector('[data-pdp-pack-qty]');
        this.label = this.querySelector('[data-pdp-pack-label]');
        this.cards = Array.from(this.querySelectorAll('[data-pdp-pack]'));
        this.root = this.closest('product-info') || document;

        this.cards.forEach((card) => {
          card.addEventListener('click', () => this.select(card));
        });

        const active = this.cards.find((card) => card.classList.contains('is-active')) || this.cards[0];
        if (active) this.select(active, { silent: false });
      }

      select(card, { silent } = {}) {
        this.cards.forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        const qty = Number(card.dataset.qty) || 1;
        const price = Number(card.dataset.price) || 0;
        const compare = Number(card.dataset.compare) || 0;
        const off = Number(card.dataset.off) || 0;
        const label = card.dataset.label || `${qty}-Pack`;

        if (this.qtyInput) this.qtyInput.value = String(qty);
        if (this.label) this.label.textContent = `: ${label}`;
        this.syncPriceRow(price, compare, off);

        this.dispatchEvent(
          new CustomEvent('pdp:pack-change', {
            bubbles: true,
            detail: { qty, price, compare, off, label },
          })
        );

        if (!silent) this.syncAtcFallback(price, compare);
      }

      syncPriceRow(price, compare, off) {
        if (this.root.querySelector('pdp-subscribe')) return;
        const row = this.root.querySelector('[data-pdp-price-row]');
        if (!row) return;

        const compareEl = row.querySelector('[data-pdp-price-compare]');
        const saleEl = row.querySelector('[data-pdp-price-sale]');
        const saveEl = row.querySelector('[data-pdp-price-save]');

        if (saleEl) saleEl.textContent = this.formatMoney(price);

        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = this.formatMoney(compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (saveEl) {
          if (off > 0 && compare > price) {
            const saved = compare - price;
            saveEl.textContent = `save ${this.formatMoney(saved)} (${off}% OFF)`;
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      }

      syncAtcFallback(price, compare) {
        if (this.root.querySelector('pdp-subscribe')) return;
        const atcPrice = this.root.querySelector('[data-pdp-atc-price]');
        const atcCompare = this.root.querySelector('[data-pdp-atc-compare]');
        if (atcPrice && price) atcPrice.textContent = this.formatMoney(price);
        if (atcCompare) {
          if (compare > price) {
            atcCompare.textContent = this.formatMoney(compare);
            atcCompare.hidden = false;
          } else {
            atcCompare.hidden = true;
          }
        }
      }

      formatMoney(cents) {
        const value = Math.round(Number(cents) || 0);
        if (window.FoxTheme?.Currency?.formatMoney) {
          return FoxTheme.Currency.formatMoney(value, '${{amount}}');
        }
        return `$${(value / 100).toFixed(2)}`;
      }
    }
  );
}
